var exports = {
  "k": "xaf9ae18d--dc82b3--container",
};

module.exports = exports;
